//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import searchAndAddMenuTemplate from '@legacy-components/content/search-and-add-menu.html';

(function() {
    /**
     * Generic list component with basic text search, selection, and creation interfaces.
     * @param {Object[]} listItems - Array of objects representing the items that should appear in the menu.
     * @param {String} listItems[].id - Unique identifier for the item.
     * @param {Object} selectedItems - Object with keys of item ids that map to booleans indicating whether an item is selected.
     * @param {Object} itemsAsyncOutstanding - Object with keys of item ids that map to booleans indicating whether an item has an outstanding async state.
     */
  angular.module('curalate').component('searchAndAddMenu', {
    bindings: {
      createButtonLabel: '@',
      createPermission: '@',
      createPlaceholderText: '@',
      itemsAsyncOutstanding: '<',
      listItems: '<',
      menuTitle: '@',
      noItemsText: '@',
      onCreate: '&',
      onSelect: '&',
      searchPlaceholderText: '@',
      selectedItems: '<',
      showCreateLoadingSpinner: '<',
    },
    template: searchAndAddMenuTemplate,
    controller: [
      '$element',
      'PermissionsService',
      function(
                $element,
                PermissionsService,
            ) {
        const self = this;

        self.searchText = '';
        self.createText = '';
        self.showCreateButton = true;

        if (self.createPermission) {
          self.hasCreatePermission = PermissionsService.hasPermissionForTask(self.createPermission);
        } else {
          self.hasCreatePermission = true;
        }

                // When the ng-switch removes the create button, focus returns to the body and closes the menu.
                // So we are returning the focus to something that isn't removed from the DOM.
        self.returnFocus = () => {
          $element.find('.create-container').focus();
        };

        self.clearButtonClicked = function() {
          self.searchText = '';
        };

        self.createButtonPressed = () => {
          self.returnFocus();
          self.showCreateButton = false;
        };

        self.createClicked = () => {
          self.onCreate({ item: self.createText });
          self.createText = '';
        };

        self.selectClicked = (item) => {
          self.onSelect({ item });
        };
      },
    ],
  });
})();
